import { contentBase as contentBaseSchema } from './content';
import { metadata } from './helpers';
import { z } from 'zod';

export const testimonialContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    when: z.string(),
    author: z.string(),
    rating: z.int().positive(),
    claim_type: z.string(),
    testimonial: z.string(),
  }),
});

export const contentTypeTestimonialContentSchema = contentBaseSchema.extend({
  content: testimonialContentSchema,
});

export type ContentTypeTestimonialContentInput = z.infer<
  typeof contentTypeTestimonialContentSchema
>;
